module.exports = __webpack_public_path__ + "img/value_ko.df34b58e.svg";